var defaultConfig = {
    appId: null,
    debugMode: false,
    currentScriptTag: null,
    shareDialog: null
};
var config = Object.assign({}, defaultConfig);

/**
 * If locale is given as language only (e.g. 'es'), try to normalize it to full locale -> es_ES
 * Facebook will default to English if the guess is wrong.
 * With just 'es' facebook would default to English anyways.
 *
 * @param {String} locale
 * @returns {String}
 */
function normalizeLocaleInfo(locale) {
    if (locale.indexOf('_') === -1) {
        locale = locale + '_' + locale.toUpperCase();
    }
    return locale;
}

function cleanupPreviousInstance() {
    delete window.FB;

    var fbRoot = document.querySelector('#fb-root');
    if (fbRoot) {
        document.body.removeChild(fbRoot);
    }

    document.head.removeChild(config.currentScriptTag);
}

var provider = {
    $get: function $get($q, LocaleService) {
        return {
            getClient: function getClient() {
                var deferred = $q.defer();
                var locale = normalizeLocaleInfo(LocaleService.getCurrentLocale());

                window.fbAsyncInit = function () {
                    var client = window.FB;
                    client.init({
                        appId: config.appId,
                        version: 'v2.5',
                        xfbml: false
                    });
                    deferred.resolve(client);
                };

                // Access control prevents loading facebook sdk with ajax
                var scriptTag = document.createElement('script');
                scriptTag.async = 'async';
                scriptTag.onerror = function () {
                    deferred.reject();
                };

                var scriptSrc = config.debugMode ? '/all/debug.js' : '/sdk.js';
                scriptTag.src = 'https://connect.facebook.net/' + locale + scriptSrc;

                if (config.currentScriptTag) {
                    cleanupPreviousInstance();
                }
                document.head.appendChild(scriptTag);
                config.currentScriptTag = scriptTag;

                return deferred.promise;
            },

            getShareDialogData: function getShareDialogData() {
                return config.shareDialog;
            }
        };
    },

    setAppId: function setAppId(appId) {
        config.appId = appId;
    },

    setDebugMode: function setDebugMode(debugMode) {
        config.debugMode = debugMode;
    },

    setShareDialogData: function setShareDialogData(data) {
        config.shareDialog = data;
    },

    reset: function reset() {
        if (config.currentScriptTag) {
            cleanupPreviousInstance();
        }
        Object.assign(config, defaultConfig);
    }
};
provider.$get.$inject = ['$q', 'LocaleService'];

export default provider;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/facebook/FacebookService.js
// module id = 1032
// module chunks = 0